import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TokenResponse } from './interceptors/auth-interceptor.service';
import { CustomKeycloakService } from './keycloak.service';

@Injectable({
  providedIn: 'root'
})
export class BaseApiService {
  public baseUrl: string = environment.baseUrl;
  public currentAccessToken: string | null = '';
  public currentRefreshToken: string | null = '';

  constructor(
    protected http: HttpClient,
    protected router: Router,
    protected keycloakService?: CustomKeycloakService
  ) {
    this.initializeTokens();
  }

  private initializeTokens(): void {
    try {
      const keycloakToken = this.keycloakService?.getStoredAccessToken();
      if (keycloakToken) {
        this.currentAccessToken = keycloakToken;
        this.currentRefreshToken =
          this.keycloakService?.getStoredRefreshToken() || null;
        return;
      }
    } catch (error) {
      console.warn('BaseApiService: Error checking Keycloak tokens:', error);
    }

    this.currentAccessToken = localStorage.getItem('access_token');
    this.currentRefreshToken = localStorage.getItem('refresh_token');
  }

  public setTokenPair(tokenResponse: TokenResponse) {
    this.currentAccessToken = tokenResponse.access;
    this.currentRefreshToken = tokenResponse.refresh;
    localStorage.setItem('access_token', tokenResponse.access);
    localStorage.setItem('refresh_token', tokenResponse.refresh);
  }
}
